import { render } from "./CustomSelectOneSystemRole.vue?vue&type=template&id=2a3a4637"
import script from "./CustomSelectOneSystemRole.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneSystemRole.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__